<div class="join-society-dialog p-4 bg-white rounded-4" style="max-width: 780px; width: 100%;">
  <!-- Header -->
  <div class="dialog-header d-flex align-items-center justify-content-between mb-4 pb-3 border-bottom">
    <div class="d-flex align-items-center gap-3">
      <div class="dialog-header-icon">
        <mat-icon>group_add</mat-icon>
      </div>
      <div>
        <h3 class="dialog-title mb-0 fw-bold">Join Society</h3>
        <p class="dialog-subtitle mb-0">Select your society, block, floor, and unit to request access.</p>
      </div>
    </div>
    <button type="button" mat-icon-button class="dialog-close-btn flex-shrink-0" (click)="closeDialog()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <form [formGroup]="joinSocietyForm" #formDirective="ngForm" (ngSubmit)="onSubmit(formDirective)">
      <div class="row g-3">
        <!-- Section Bar -->
        <div class="col-12">
          <div class="dialog-section-bar mb-1">
            <div class="section-icon-circle">
              <mat-icon>domain</mat-icon>
            </div>
            <h4 class="section-bar-title mb-0">Society & Unit Details</h4>
          </div>
        </div>

        <!-- Society -->
        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>Society</mat-label>
          <input type="text" matInput [matAutocomplete]="autoSociety" formControlName="account_id" placeholder="Search society" />
          <mat-autocomplete #autoSociety="matAutocomplete" [displayWith]="displaySociety">
            <mat-option *ngFor="let soc of filteredSocieties | async" [value]="soc">
              {{ soc.account_name }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="joinSocietyForm.get('account_id')?.hasError('required')">Society is required</mat-error>
          <mat-icon matSuffix>arrow_drop_down</mat-icon>
        </mat-form-field>

        <!-- Block -->
        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>Block</mat-label>
          <input type="text" matInput [matAutocomplete]="autoBlock" formControlName="block_id" placeholder="Search block" />
          <mat-autocomplete #autoBlock="matAutocomplete" [displayWith]="displayBlock">
            <mat-option *ngFor="let blk of filteredBlocks | async" [value]="blk">{{ blk.name }}</mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="joinSocietyForm.get('block_id')?.hasError('required')">Block is required</mat-error>
          <mat-icon matSuffix>arrow_drop_down</mat-icon>
        </mat-form-field>

        <!-- Floor -->
        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>Floor</mat-label>
          <input type="text" matInput [matAutocomplete]="autoFloor" formControlName="floor_id" placeholder="Search floor" />
          <mat-autocomplete #autoFloor="matAutocomplete" [displayWith]="displayFloor">
            <mat-option *ngFor="let flr of filteredFloors | async" [value]="flr">{{ flr.name }}</mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="joinSocietyForm.get('floor_id')?.hasError('required')">Floor is required</mat-error>
          <mat-icon matSuffix>arrow_drop_down</mat-icon>
        </mat-form-field>

        <!-- Floor Unit -->
        <mat-form-field appearance="outline" class="col-md-6">
          <mat-label>Floor Unit</mat-label>
          <input type="text" matInput [matAutocomplete]="autoUnit" formControlName="floor_unit" placeholder="Search unit" />
          <mat-autocomplete #autoUnit="matAutocomplete" [displayWith]="displayUnit">
            <mat-option *ngFor="let unt of filteredUnits | async" [value]="unt">{{ unt.name }}</mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="joinSocietyForm.get('floor_unit')?.hasError('required')">Floor unit is required</mat-error>
          <mat-icon matSuffix>arrow_drop_down</mat-icon>
        </mat-form-field>

        <!-- Section Bar 2: Attachment -->
        <div class="col-12 mt-2">
          <div class="dialog-section-bar mb-1">
            <div class="section-icon-circle">
              <mat-icon>attach_file</mat-icon>
            </div>
            <h4 class="section-bar-title mb-0">Verification Attachment</h4>
          </div>
        </div>

        <!-- Upload Attachment -->
        <div class="col-12 mb-2">
          <label class="form-label small fw-semibold text-secondary mb-1">Upload Document / Photo</label>
          <div class="file-info mb-2 d-flex align-items-center justify-content-between p-2 rounded border bg-light">
            <div class="d-flex align-items-center gap-2">
              <button type="button" mat-stroked-button color="primary" class="rounded-pill" (click)="fileInput.click()">
                <mat-icon class="me-1">upload_file</mat-icon> Choose file
              </button>
              <input type="file" formControlName="documents" class="d-none"
                     (change)="onFileSelected($event)" #fileInput />
              <span class="small text-muted" *ngIf="selectedFile">{{ selectedFile.name }}</span>
            </div>
          </div>

          <!-- Image Preview -->
          <div class="d-flex align-items-center gap-2 mt-2" *ngIf="attachmentPreview">
            <img [src]="attachmentPreview" alt="Uploaded Document" width="100" height="100"
                 class="rounded border" style="object-fit: cover;">
            <button type="button" mat-icon-button color="warn" (click)="deleteFile()" aria-label="Delete file">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="dialog-actions d-flex justify-content-end gap-2 pt-3 border-top mt-3">
        <button type="button" class="btn btn-outline-secondary rounded-pill px-4" (click)="closeDialog()" [disabled]="loading">Cancel</button>
        <button type="submit" class="gold-button" [disabled]="joinSocietyForm.invalid || loading">
          <span *ngIf="!loading">Join Society</span>
          <span *ngIf="loading">Joining...</span>
        </button>
      </div>
    </form>
  </div>
</div>
